import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import store from "./Redux/store";
import { getConfig } from "./config";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Auth0ProviderOptions } from "@auth0/auth0-react";

const config = getConfig();

export const providerConfig: Auth0ProviderOptions = {
  domain: config.domain,
  clientId: config.clientId,
  audience: config.audience,
  redirectUri: window.location.origin,
};

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <Provider store={store}>
        <App />
      </Provider>
    </Provider>
  </StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
